import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

interface ShoppingList {
  id: number;
  name: string;
  city: string;
  updated_at: string;
}

const ListsPage = () => {
  const [lists, setLists] = useState<ShoppingList[]>([]);
  const [newName, setNewName] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/lists')
      .then(res => setLists(res.data))
      .finally(() => setLoading(false));
  }, []);

  const createList = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newName.trim()) return;
    const res = await api.post('/lists', { name: newName });
    setLists(prev => [res.data, ...prev]);
    setNewName('');
  };

  const deleteList = async (e: React.MouseEvent, id: number) => {
    e.stopPropagation();
    if (!window.confirm('Διαγραφή αυτής της λίστας;')) return;
    await api.delete(`/lists/${id}`);
    setLists(prev => prev.filter(l => l.id !== id));
  };

  if (loading) return <div style={S.center}>Φόρτωση...</div>;

  return (
    <div style={S.page}>
      <h1 style={S.heading}>🛒 Οι Λίστες μου</h1>

      <form onSubmit={createList} style={S.createRow}>
        <input
          value={newName}
          onChange={e => setNewName(e.target.value)}
          placeholder="Όνομα νέας λίστας..."
          style={S.input}
        />
        <button type="submit" style={S.btn}>+ Δημιουργία</button>
      </form>

      {lists.length === 0 ? (
        <p style={S.empty}>Δεν υπάρχουν λίστες ακόμα. Δημιούργησε την πρώτη σου!</p>
      ) : (
        <div style={S.listContainer}>
          {lists.map(list => (
            <div
              key={list.id}
              style={S.card}
              onClick={() => navigate(`/lists/${list.id}`)}
            >
              <div style={S.cardLeft}>
                <span style={S.listName}>{list.name}</span>
                <span style={S.listDate}>
                  Ενημερώθηκε {new Date(list.updated_at).toLocaleDateString('el-GR')}
                </span>
              </div>
              <div style={S.cardRight} onClick={e => e.stopPropagation()}>
                <button
                  onClick={() => navigate(`/lists/${list.id}/optimize`)}
                  style={S.optimizeBtn}
                >
                  💡 Σύγκριση
                </button>
                <button onClick={e => { e.stopPropagation(); window.open(`/lists/${list.id}`, '_blank', 'width=800,height=600'); setTimeout(() => window.print(), 500); }} style={S.printBtn}>🖨️</button>
                <button onClick={e => deleteList(e, list.id)} style={S.deleteBtn}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const S: Record<string, React.CSSProperties> = {
  page: { maxWidth: 720, margin: '0 auto', padding: '24px 16px', fontFamily: 'Arial, sans-serif' },
  heading: { color: '#2952CC', fontSize: 22, marginBottom: 20 },
  createRow: { display: 'flex', gap: 8, marginBottom: 24 },
  input: { flex: 1, padding: '11px 14px', borderRadius: 8, border: '1.5px solid #C5D5FF', fontSize: 15 },
  btn: { padding: '11px 22px', background: '#2952CC', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer' },
  empty: { color: '#999', textAlign: 'center', marginTop: 40 },
  center: { textAlign: 'center', marginTop: 80, color: '#888' },
  listContainer: { display: 'flex', flexDirection: 'column', gap: 10 },
  card: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'white', borderRadius: 10, padding: '16px 20px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', cursor: 'pointer', transition: 'box-shadow 0.15s' },
  cardLeft: { display: 'flex', flexDirection: 'column', gap: 4, flex: 1 },
  listName: { fontWeight: 600, fontSize: 16, color: '#2952CC' },
  listDate: { fontSize: 12, color: '#888' },
  cardRight: { display: 'flex', gap: 8 },
  optimizeBtn: { padding: '7px 14px', background: '#EAFAF1', color: '#27AE60', border: '1px solid #A9DFBF', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  printBtn: { padding: '7px 10px', background: '#F0F4F8', color: '#2952CC', border: '1px solid #C5D5FF', borderRadius: 6, fontSize: 14, cursor: 'pointer' },
  deleteBtn: { padding: '7px 10px', background: '#FEF9F9', color: '#E74C3C', border: '1px solid #FADBD8', borderRadius: 6, fontSize: 14, cursor: 'pointer' },
};

export default ListsPage;
